import Loading from './../misc/Loading';
import React from 'react';
import ColorComponent from './Color';
import colorModel from '../../../../model/color';
import modelModel from '../../../../model/model';
import update from 'immutability-helper';
import ValidationError from '../../../../model/error/ValidationError';
import {NavLink as Link} from 'react-router-dom';
import withRouter from '/src/components/misc/withRouter';

const errorToMessage = (error) => {
  console.error(error);
  if (error instanceof ValidationError) {
    return 'Fargen validerer ikke og kan dermed ikke publiseres. Sjekk at alle påkrevede felter er fylt ut med gyldige verdier og prøv igjen.';
  }

  return 'En ukjent feil inntraff ved behandling av fargen og handlingen kunne dermed ikke fullføres.';
};

class ColorContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      color: null,
      model: null,
      modelId: null,
      modified: false,
      working: false,
      error: null
    };

    this.handlePublish = this.handlePublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleArchive = this.handleArchive.bind(this);
    this.handleUnarchive = this.handleUnarchive.bind(this);
  }

  componentDidMount() {
    let colorId = null;
    if (this.props.match.params.colorId && this.props.match.params.colorId !== 'new') {
      colorId = this.props.match.params.colorId;
    }

    if (colorId && this.props.match.params.modelId) {
      Promise.all([
        colorModel.getById(this.props.match.params.colorId, 2),
        modelModel.getById(this.props.match.params.modelId, 2)
      ]).then(([color, model]) => {
        document.title = `Admin - Farge - ${model.name} - ${color.name}`;
        this.setState({
          color: color,
          model: model,
          modelId: this.props.match.params.modelId
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    } else {
      Promise.all([
        colorModel.createEmpty(),
        modelModel.getById(this.props.match.params.modelId, 2)
      ]).then(([color, model]) => {
        color.model = model;
        this.setState({
          color: color,
          model: model,
          modelId: this.props.match.params.modelId
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    }
  }

  handleSave() {
    this.setState({
      error: null,
      working: true,
      modified: false
    });

    const isCreate = !this.state.color.id;

    if (isCreate) {
      colorModel.new(this.state.color, 2).then((color) => {
        this.setState({
          working: false,
          color: color
        });
        this.props.history.push(`/farge/${color.id}/${this.state.modelId}`);
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    } else {
      colorModel.save(this.state.color, 2).then((color) => {
        this.setState({
          working: false,
          color: color
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    }
  }

  handlePublish() {
    this.setState({
      error: null,
      working: true
    });
    colorModel.publish(this.state.color.id, 2).then((color) => {
      this.setState({
        working: false,
        color: color
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnpublish() {
    this.setState({
      error: null,
      working: true
    });
    colorModel.unpublish(this.state.color.id, 2).then((color) => {
      this.setState({
        working: false,
        color: color
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleArchive() {
    this.setState({
      error: null,
      working: true
    });
    colorModel.archive(this.state.color.id, 2).then((color) => {
      this.setState({
        working: false,
        color: color
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnarchive() {
    this.setState({
      error: null,
      working: true
    });
    colorModel.unarchive(this.state.color.id, 2).then((color) => {
      this.setState({
        working: false,
        color: color
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleChange(props) {
    const state = update(props, {
      modified: {
        $set: true
      }
    });

    this.setState(state);
  }

  render() {
    if (!this.state.color) {
      return (
        <section className="color mf-padding-top-20">
          <ol className="breadcrumb">
            <li><Link to="/">Forsiden</Link></li>
            <li><Link to={'/nybilinformasjon/'}>Nybilinformasjon</Link></li>
            <li className="active">...</li>
          </ol>
          <Loading title="Farge" text="Laster farge" />
        </section>
      );
    }

    return (
      <ColorComponent
        color={this.state.color}
        model={this.state.model}
        error={this.state.error}
        modified={this.state.modified}
        working={this.state.working}
        onChange={this.handleChange}
        onSave={this.handleSave}
        onPublish={this.state.color.id ? this.handlePublish : null}
        onUnpublish={this.state.color.id ? this.handleUnpublish : null}
        onArchive={this.state.color.id ? this.handleArchive : null}
        onUnarchive={this.state.color.id ? this.handleUnarchive : null}
      />
    );
  }
}

ColorContainer.defaultProps = {
};

export default withRouter(ColorContainer);
